export default __webpack_public_path__ + "static/media/stanzaLogo.01f383d4.svg";